import React from 'react';

import styles from './not-authorized.module.scss';
import Page from '@/components/Page/Page';

interface INotAuthorizedProps {
  withBreadcrumbsOffset?: boolean;
  text?: string;
}

export default function NotAuthorized({
  withBreadcrumbsOffset,
  text = 'You are not authorized to view this page'
}: INotAuthorizedProps) {
  return (
    <Page
      pageTitle="Page 403"
      className={styles['not-authorized']}
      withBreadcrumbsOffset={withBreadcrumbsOffset}
    >
      <h1>403</h1>
      <h2>{text}</h2>
    </Page>
  );
}
